import { render } from "./msgContextBody.vue?vue&type=template&id=e652104c"
import script from "./msgContextBody.vue?vue&type=script&lang=js"
export * from "./msgContextBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__